'use strict';

import $ from 'jquery';
import { Promise } from 'bluebird';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const extlinkImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAAAAAAevcqWAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADwSURBVBhXDY+7SgNhFIQHEmNlFJJGImgTDIIxuo1FChERTaWFVuLzWPgOgbQBxYCQQgttbARBEUGECGuwyXXJ5t/d/zI55QzfzDmDMWlpFDkJtWUfNMOEQ070y4qXKuzDP6wuF4pbq1f9I8wDOK7dt9vPNw/vdNm5RTG+pSAgmRykciIxHTtanQxO0+WvS9ECWjI6wU5o2EDaF9RFNZTjqaVC5pd0gyq8rn8bkkDHKXaXvB6vi5R/IPzI/XQYtDZjpZHtMdByjqxvUPLb50+Pn293rx/NvYtI8v+7pfzaemUhXzqTaYSh0vxzjDkyTNQMBWGaYlBbWTgAAAAASUVORK5CYII=';

const StateAbbs = {
  NSW: 'New South Wales',
  WA: 'Western Australia',
  ACT: 'Australian Capital Territory',
  NT: 'Northern Territory',
  QLD: 'Queensland',
  SA: 'South Australia',
  TAS: 'Tasmania',
  VIC: 'Victoria',
};

const CellPadding = 3.5;
const CategoryFillArr = [252, 242, 232];
const CategoryLineArr = [221, 221, 221];
const DarkRedArr = [107, 47, 70];
const DarkRedHex = '#6b2f46';
const RedArr = [173, 33, 64];
const RedHex = '#ad2140';
const DarkBlueArr = [44, 71, 89];
const DarkBlueHex = '#2c4759';
const BlueArr = [0, 86, 112];
const BlueHex = '#005670';
const MidGreyArr = [175, 168, 167];
const LightGreyArr = [224, 220, 220];
const LightGreyHex = '#e0dcdc';
const LineHex = '#e1e1e1';
const WhiteArr = [255, 255, 255];
const WhiteHex = '#ffffff';
const BlackArr = [0, 0, 0];
const BlackHex = '#000000';

const StateArray = [
  'National',
  'NSW',
  'VIC',
  'QLD',
  'WA',
  'SA',
  'TAS',
  'ACT',
  'NT',
];
const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const dateToday = new Date();

const CategoryData = [
  {
    key: 'Access to Water',
    description:
      'Improving the access and reliability of water collection, storage or distribution infrastructure for potable or non-potable purposes.',
  },
  {
    key: 'Adaptation and resilience',
    description:
      'Enhancing the capacity and reliability of Australia’s infrastructure networks to prepare for or regenerate after a particular shock and recover rapidly to the previous level of service or better.',
  },
  {
    key: 'Asset Renewal',
    description:
      'Replacing or refurbishing an existing asset to return it to its original level of service and extend its life.',
  },
  {
    key: 'Corridor Preservation',
    description:
      'Protection and early acquisition of land needed for future infrastructure delivery, to save on land purchase and construction costs.',
  },
  {
    key: 'Efficient Markets',
    description:
      'Lowering barriers-to-entry and fostering competition to make better use of resources and minimise costs for businesses and consumers.',
  },
  {
    key: 'Efficient transport networks',
    description:
      'Addressing excess traffic movements on transport networks in Australia’s cities and regions.',
  },
  {
    key: 'Energy Transformation',
    description:
      'Enabling or contributing to the transition to lower carbon-emission electricity generation and/or enabling access to reliable and cost efficient energy.',
  },
  {
    key: 'National Connectivity',
    description:
      'Improving the ease of movement from one part of Australia to another, for people, goods and services.',
  },
  {
    key: 'Remote Infrastructure',
    description:
      'Delivery of quality services and infrastructure in remote areas of Australia to improve quality of life for residents and enhance opportunities for social and economic development.',
  },
  {
    key: 'Regional Connectivity',
    description:
      'Improving the ease of movement from one part of a region to another, for people, goods and services.',
  },
  {
    key: 'Road Safety',
    description:
      'Reducing the risk and number of crashes, injuries and deaths on Australia’s roads.',
  },
  {
    key: 'Precinct Activation',
    description:
      'Supports place-making through the provision of facilities, spaces, services and networks that support the quality of life and socio-economic wellbeing of our communities. This can include a variety of sectors (including health, education, recreation, arts or housing) and be underpinned by enabling infrastructure such as transport, energy, telecommunications and water.',
  },
  {
    key: 'Sustainability',
    description:
      'Meeting the needs of the present without compromising the ability of future generations to meet their own needs.',
  },
];

const getIplType = (priority, iplType) => {
  if (priority == 'High Priority' && iplType == 'Project') {
    return 'highpriority_project';
  } else if (priority == 'Priority' && iplType == 'Project') {
    return 'priority_project';
  } else if (priority == 'High Priority' && iplType == 'Initiative') {
    return 'highpriority_initiative';
  } else if (priority == 'Priority' && iplType == 'Initiative') {
    return 'priority_initiative';
  }
};

const getIplData = () =>
  new Promise((resolve, reject) => {
    let iplData = {
      "Early-stage proposal (Stage 1)": {
        title: 'Early-stage proposals (Stage 1)',
        name: 'Proposal name',
        fillColor: BlueArr,
        lineColor: BlueHex
      },
      "Potential investment options (Stage 2)": {
        title: 'Potential investment options (Stage 2)',
        name: 'Proposal name',
        fillColor: BlueArr,
        lineColor: BlueHex
      },
      "Investment-ready proposal (Stage 3)": {
        title: 'Investment-ready proposals (Stage 3)',
        name: 'Proposal name',
        fillColor: BlueArr,
        lineColor: BlueHex
      },
      "Funded proposal": {
        title: 'Funded proposals',
        name: 'Proposal name',
        fillColor: BlueArr,
        lineColor: BlueHex
      },
      "Proposal in delivery": {
        title: 'Proposals in delivery',
        name: 'Proposal name',
        fillColor: BlueArr,
        lineColor: BlueHex
      },
      "Delivered project": {
        title: 'Delivered projects',
        name: 'Proposal name',
        fillColor: BlueArr,
        lineColor: BlueHex
      }
      /*
      highpriority_project: {
        title: 'High Priority Projects',
        name: 'Project name',
        fillColor: DarkRedArr,
        lineColor: DarkRedHex
      },
      priority_project: {
        title: 'Priority Projects',
        name: 'Project name',
        fillColor: RedArr,
        lineColor: RedHex
      },
      highpriority_initiative: {
        title: 'High Priority Initiatives',
        name: 'Initiative name',
        fillColor: DarkBlueArr,
        lineColor: DarkBlueHex
      },
      priority_initiative: {
        title: 'Priority Initiatives',
        name: 'Initiative name',
        fillColor: BlueArr,
        lineColor: BlueHex
      }
      */
    };

    $.getJSON('/ipl-map/map-pdf.json', function (data) {
      $.each(data, function (index, data) {
        if (!data.Title) {
          return;
        }

        if(!iplData[data.field_ipl_map_type]) {
          return;
        }

        const dataNational = data.National;
        const dataPriority = data.Priority;
        const dataType = data.Type;
        const dataNewType = data.field_ipl_map_type;
        const dataState = data.field_location_description;
        const dataName = data.Title;
        const dataDescription = data.field_problem_description;
        const dataTimeframe = data.timeframe;
        const dataCategory = data.Sector;
        const dataSector = data.field_infrastructure_category;
        const dataLink = data.content_url;
        const dataDate = new Date(data.date);
        const dateString =
          dataDate.getDate() +
          ' ' +
          months[dataDate.getMonth()] +
          ' ' +
          dataDate.getFullYear();

        const iplType = dataNewType;
        let states =
          dataNational == 'Yes' || dataState == ''
            ? ['National']
            : dataState.split(',').map((s) => s.trim());

        const itemData = {
          name: decodeHtml(dataName),
          description: decodeHtml(dataDescription),
          timeframe:
            dataTimeframe.slice(0, dataTimeframe.indexOf('(')) +
            '\n' +
            dataTimeframe.slice(
              dataTimeframe.indexOf('('),
              dataTimeframe.length
            ),
          sector: dataSector,
          category: dataCategory,
          date: dateString,
          link: dataLink,
        };

        states
          .filter((item, index) => {
            return states.indexOf(item) === index;
          })
          .forEach((item, index) => {
            if (!iplData[iplType][item]) iplData[iplType][item] = [];

            iplData[iplType][item].push(itemData);
            iplData[iplType].hasValue = true;
          });
      });

      Object.keys(iplData).forEach((type) => {
        StateArray.forEach((state) => {
          if (iplData[type][state]) {
            iplData[type][state] = iplData[type][state].sort((a, b) => {
              if (a.name > b.name) {
                return 1;
              } else if (a.name < b.name) {
                return -1;
              } else {
                return 0;
              }
            });
          }
        });
      });

      resolve(iplData);
    });
  });
const decodeHtml = (html) => {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}
const getIplBody = (data) => {
  let body = [];

  StateArray.forEach((state, index) => {
    if (!data[state]) {
      return;
    }

    let row = data[state];
    row.unshift([
      {
        content: state == 'National' ? 'National' : StateAbbs[state],
        colSpan: 5,
        styles: {
          fillColor: LightGreyArr,
          textColor: BlackArr,
          fontStyle: 'bold',
        },
      },
    ]);
    body = body.concat(row);
  });

  return body;
};

$(document).ready(function () {
  const $iplLink = $('.ip-pdf-generate a[href*=".pdf"]');

  $iplLink.on('click', (e) => {
    // if ($(e.target).text().trim() !== 'current Infrastructure Priority List') {
    //  // return;
    // }

    e.preventDefault();

    let doc = new jsPDF().setProperties({
      title: 'Infrastructure Priority List',
    });

    const pageSize = doc.internal.pageSize;
    const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

    const drawLine = (color, positionY, lineWidth) => {
      positionY = positionY;
      doc.setDrawColor(color);
      doc.setLineWidth(lineWidth);
      doc.line(14, positionY, pageWidth - 14, positionY);
    };

    const createHeaderFooter = (data) => {
      // Header
      doc.setFontSize(8);
      doc.setFontStyle('normal');
      doc.setTextColor(RedHex);
      doc.text('Infrastructure Priority List', data.settings.margin.left, 10);

      // Footer
      const pageNo = doc.internal.getNumberOfPages() + '';
      doc.setFontSize(10);
      doc.text(pageNo, pageWidth - data.settings.margin.left, pageHeight - 10, {
        align: 'right',
      });

      const dataText =
        months[dateToday.getMonth()] + ' ' + dateToday.getFullYear();
      doc.text(dataText, data.settings.margin.left, pageHeight - 10);
    };

    const renderIplTable = (data, isInitiative) => {
      doc.addPage();

      doc.autoTable({
        startY: 25,
        head: [{ title: data.title }],
        margin: { top: 25, right: 14, bottom: 25, left: 14 },
        styles: {
          fontSize: 16,
          fillColor: data.fillColor,
          lineWidth: 0,
          cellPadding: CellPadding,
        },
      });

      let finalY = doc.previousAutoTable.finalY;

      doc.autoTable({
        startY: finalY + 0.2,
        head: [
          {
            name: data.name,
            description: 'Problem/opportunity description',
            timeframe: 'Timeframe (years)',
            sector: 'Sector',
            category: 'Outcome category',
          },
        ],
        rowPageBreak: 'avoid',
        body: getIplBody(data),
        theme: 'plain',
        margin: { top: 25, right: 14, bottom: 25, left: 14 },
        styles: {
          cellPadding: CellPadding,
        },
        headStyles: {
          fillColor: MidGreyArr,
          textColor: WhiteArr,
          lineColor: WhiteArr,
          lineWidth: 0.1,
          valign: 'bottom',
        },
        bodyStyles: {
          fontSize: 9,
          lineWidth: 0,
        },
        columnStyles: {
          name: { fontStyle: 'bold', minCellWidth: 40 },
          description: { minCellWidth: 40 },
        },
        didParseCell: function (cellData) {
          if (cellData.section === 'body') {
            if (cellData.cell.colSpan === 1 && cellData.column.index === 0) {
              cellData.cell.styles.textColor = BlueHex;
            }
          }
        },
        didDrawCell: function (cellData) {
          if (cellData.section == 'body') {
            if (cellData.cell.colSpan == 5) {
              drawLine(WhiteHex, cellData.row.y - 0.1, 0.1);
            }

            if (cellData.cell.colSpan == 1) {
              drawLine(LightGreyHex, cellData.row.y + cellData.row.height, 0.1);

              if (cellData.column.index == 0) {
                doc.link(
                  cellData.cell.x,
                  cellData.cell.y,
                  cellData.cell.width,
                  cellData.cell.height,
                  {
                    url: cellData.row.raw.link,
                    width: 10,
                  }
                );

                // console.log(cellData.cell);
                doc.setDrawColor(BlueHex);
                doc.setLineWidth(.2);
                let undHeightFactor = 3.5;
                // Task: draw an underline for the link
                for (var i = 0; i < cellData.cell.text.length; i++) {
                  // For each line of text
                  // get the width of the line itself,
                  let undWidth = doc.getTextWidth(cellData.cell.text[i]);
                  // get the height where the line should be,
                  let undHeight = cellData.cell.y + 3.6 + ((i + 1) * undHeightFactor); // 3.6 represents the offset from the top of the cell.
                  // then draw the line in the appropriate location.
                  // doc.line(cellData.cell.x + 3.5,
                  //   undHeight,
                  //   cellData.cell.x + 3.5 + undWidth,
                  //   undHeight,
                  //   'S');

                  if (i === cellData.cell.text.length - 1 ) {
                    doc.addImage(extlinkImg,
                      'PNG',
                      cellData.cell.x + 4.5 + undWidth,
                      undHeight - 3.6,
                      3,
                      3,
                      'external_link',
                      'NONE',
                      0);
                  }
                }
              }
            }
          }
        },
        didDrawPage: function (pageData) {
          createHeaderFooter(pageData);
        },
      });

      finalY = doc.previousAutoTable.finalY;
      drawLine(data.lineColor, finalY, 0.4);
    };

    /* print pdf */
    let finalY = 35;

    // add title
    doc.setFontSize(45);
    doc.setFontStyle('normal');
    doc.setTextColor(RedHex);
    doc.text('Infrastructure Priority List', 14, finalY);

    finalY = finalY + 40 / 2.835 + 0;

    doc.setFontSize(18);
    doc.text('As at ', 14, finalY);
    doc.text(
      dateToday.getDate() + ' ' + months[dateToday.getMonth()] + ' ' + dateToday.getFullYear(),
      30.2,
      finalY
    );

    finalY = finalY + 40 / 2.835 + 0;

    // add intro text
    doc.setFontSize(14);
    doc.setTextColor(BlackHex);
    const introText = doc.splitTextToSize(
      "The Infrastructure Priority List is changing in line with amendments to the Infrastructure Australia Act 2008. (",
      pageWidth - 28,
      {}
    );

    
    doc.text(introText, 14, finalY);
    
    finalY = finalY + ((introText.length - 1) * 14 * 1.15) / 2.835;

    doc.setTextColor(BlueHex);
    doc.textWithLink('here', 90, finalY, { url: 'https://www.infrastructureaustralia.gov.au/infrastructure-priority-list' });
  
    doc.setTextColor(BlackHex);
    const introText_last = doc.splitTextToSize(
      ").",
      pageWidth - 125.3,
      {}
    );

    doc.text(introText_last, 101, finalY);

    finalY = finalY + ((1 * 14 * 1.15) / 2.835);

    const introText_last_line = doc.splitTextToSize(
      "",
      pageWidth - 28,
      {}
    );
    doc.text(introText_last_line, 14, finalY);

    doc.setTextColor(BlueHex);
    doc.textWithLink('', 103, finalY, { url: '' });
  
    doc.setTextColor(BlackHex);

    doc.text('', 113, finalY);


    finalY = finalY + ((introText_last_line.length) * 16 * 1.2) / 2.835;

    // add sub intro text
    doc.setFontSize(10);
    const subIntroText = doc.splitTextToSize(
      'Proposals are organised according to their stage of development and location. Proposals are not ranked and are listed in alphabetical order.',
      pageWidth - 28,
      {}
    );
    doc.text(subIntroText, 14, finalY);

    finalY = finalY + (subIntroText.length * 10 * 1.2) / 2.835 + 5;

    // add category table
    doc.setFontSize(12);
    doc.setTextColor(RedHex);
    doc.text('Outcome Category and descriptions', 14, finalY);

    finalY = finalY + 12 / 2.835;

    drawLine(RedHex, finalY - 0.5, 0.4);

    doc.autoTable({
      startY: finalY,
      head: [{ key: 'key', description: 'description' }],
      body: CategoryData,
      showHead: false,
      theme: 'plain',
      tableLineColor: WhiteArr,
      tableLineWidth: 0.1,
      styles: {
        fillColor: CategoryFillArr,
        lineColor: CategoryLineArr,
        lineWidth: 0.1,
        cellPadding: 2,
      },
      columnStyles: {
        key: { fontStyle: 'bold', minCellWidth: 50 },
      },
      didDrawPage: function (pageData) {
        createHeaderFooter(pageData);
      },
    });

    finalY = doc.previousAutoTable.finalY;
    drawLine(RedHex, finalY, 0.4);

    getIplData().then((iplData) => {
      /*
      renderIplTable(iplData.highpriority_project);
      renderIplTable(iplData.priority_project);
      renderIplTable(iplData.highpriority_initiative, true);
      renderIplTable(iplData.priority_initiative, true);
      */
      if(iplData["Early-stage proposal (Stage 1)"].hasValue)renderIplTable(iplData["Early-stage proposal (Stage 1)"]);
      if(iplData["Potential investment options (Stage 2)"].hasValue)renderIplTable(iplData["Potential investment options (Stage 2)"]);
      if(iplData["Investment-ready proposal (Stage 3)"].hasValue)renderIplTable(iplData["Investment-ready proposal (Stage 3)"]);
      if(iplData["Funded proposal"].hasValue)renderIplTable(iplData["Funded proposal"]);
      if(iplData["Proposal in delivery"].hasValue)renderIplTable(iplData["Proposal in delivery"]);
      if(iplData["Delivered project"].hasValue)renderIplTable(iplData["Delivered project"]);

      doc.save('current_priority_list.pdf');
    });
  });
});
